import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './LoginPageLayout.module.css';

export type LoginPageLayoutProps = ComponentProps<'div'>;

export const LoginPageLayout: FunctionComponent<LoginPageLayoutProps> =
  React.memo((props) => {
    const { children, className, ...remainingProps } = prepareProps({ props });

    return (
      <div
        {...remainingProps}
        className={classes(className, styles.pageWrapper)}
      >
        <div className={styles.headerPlaceholder}>
          <header className={styles.fixedContent}>
            <div className={styles.header}></div>
          </header>
        </div>
        <main className={styles.contentWrapper}>{children}</main>
      </div>
    );
  });
